import React, { useState, useEffect } from "react";
import authFetch from "../axios";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const ActivityLog = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 1,
  });

  useEffect(() => {
    const fetchLogs = async () => {
      setLoading(true);
      try {
        const response = await authFetch.get(`/activity-log?page=${lazyParams.page}&per_page=${lazyParams.rows}`);
        if (response?.data?.success) {
          setLogs(response.data.data);
          setTotalRecords(response.data.pagination.total);
        } else {
          setLogs([]);
          setTotalRecords(0);
        }
      } catch (error) {
        console.error("Error fetching activity logs:", error);
        setLogs([]);
        setTotalRecords(0);
      } finally {
        setLoading(false);
      }
    };

    fetchLogs();
  }, [lazyParams]);

  const onPage = (event) => {
    setLazyParams({
      first: event.first,
      rows: event.rows,
      page: event.page + 1 // PrimeReact page is 0-indexed, our API is 1-indexed
    });
  };

  const serialNumberTemplate = (rowData, options) => {
    return lazyParams.first + options.rowIndex + 1;
  };

  return (
    <div className="surface-card p-5 shadow-2 border-round">
      <div className="text-3xl font-bold text-900 mb-4">Activity Logs</div>
      <p className="text-600 mb-5">View recent actions and system events performed by accounts.</p>
      
      <DataTable 
        value={logs} 
        lazy 
        loading={loading} 
        responsiveLayout="scroll" 
        stripedRows 
        paginator 
        first={lazyParams.first}
        rows={lazyParams.rows} 
        totalRecords={totalRecords}
        onPage={onPage}
        className="p-datatable-sm"
      >
        <Column header="S/N" body={serialNumberTemplate} className="font-medium" style={{ minWidth: '5rem' }}></Column>
        <Column field="account_name" header="Account Name"></Column>
        <Column field="activity_done" header="Activity Done"></Column>
        <Column field="date" header="Date"></Column>
      </DataTable>
    </div>
  );
};

export default ActivityLog;